import axios from "axios";
import { Base } from "../config";

export const getPriceRanges = async (calendarName, startDate, endDate) => {
  try {
    const response = await axios.get(
      `${Base}/calendar/listEvents/${encodeURIComponent(
        calendarName
      )}/${encodeURIComponent(startDate)}/${encodeURIComponent(endDate)}`
    );

    return { data: response.data, status: response.status, error: null };
  } catch (err) {
    return {
      data: err?.response?.data ?? null,
      status: err?.response?.status ?? 500,
      error: "Error fetching price ranges",
    };
  }
};

/**
 * Fetch raw ICS text via your backend proxy:
 * GET {Base}/calendar/ics?url=<encoded VRBO ics url>
 */
export const getIcsText = async (icsUrl) => {
  try {
    const response = await axios.get(`${Base}/calendar/ics`, {
      params: { url: icsUrl },
      // Make sure axios returns raw text, not JSON parsing
      responseType: "text",
    });

    return { data: response.data, status: response.status, error: null };
  } catch (err) {
    return {
      data: null,
      status: err?.response?.status ?? 500,
      error: "Error fetching iCal feed",
    };
  }
};
